import axios from '@/lib/AxApi';

export default {
    selectRow(params, cb)
    {
        axios.get('/Users/selectRow',
            {
                params,
            })
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    save(params, cb)
    {
        if (typeof params.id !== 'undefined' && params.id != '')
        {
            axios.post('/Users/updateRow', params)
                .then((response) =>
                {
                    cb(response.data);
                })
                .catch((e) =>
                {
                    // TODO
                });
        }
        else
        {
            axios.post('/Users/insertRow', params)
                .then((response) =>
                {
                    cb(response.data);
                })
                .catch((e) =>
                {
                    // TODO
                });
        }
    },
    deleteRow(params, cb)
    {
        axios.post('/Users/deleteRow', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    registerUser(params, cb)
    {
        axios.post('/Users/registerUser', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
};
